module.exports = "/_next/static/images/marginCompare-min-33b2c05be902a52222bd5807d8a657f3.png";